export const getJwtToken = () => localStorage.getItem("TOKEN");
export const setJwtToken = value => localStorage.setItem("TOKEN", value);
export const deleteJwtToken = () => localStorage.removeItem("TOKEN");

export const setUserSession = value => localStorage.setItem("user", JSON.stringify(value));
export const getUserSession = () => JSON.parse(localStorage.getItem("user") || "null");
export const deleteUserSession = () => localStorage.removeItem("user");

export const setDeviceUUID = value => localStorage.setItem("DEVICE_UUID", value);
export const getDeviceUUID = () => localStorage.getItem("DEVICE_UUID");
export const deleteDeviceUUID = () => localStorage.removeItem("DEVICE_UUID");
